export function isPromise (value) {
  return value !== undefined && value !== null && typeof value.then === 'function'
}
